// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-prestige -> mox-theme-prestige -> the-six-eight
// Generated: 2026-10-20T17:17:50.169Z
// Counts: 1 design, 20 content, 8 slot group, 0 collection binding, 7 section, 2 style

export const designOverrides = {
  "design.block:multihub-lead-form.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  }
};

export const contentOverrides = {
  "header.interactive_map_show_if_exists": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=160/company/5767906449162466/01a01059-a5e2-7667-9dee-e75a334c3f2a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqlist.footer_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Still have questions?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Questions about THE’68 at Hemisfair?</strong> Start here for quick answers on the community, leasing, apartment features, and everyday living in the heart of Hemisfair. If you need more detail, the <a class=\"richtext-link\" href=\"/contact-us\">leasing team</a> is happy to help you take the next step.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Find the layout that matches your everyday rhythm.</strong> At THE'68 at Hemisfair, available floor plans range from efficient studios to roomy one- and two-bedroom apartments in Hemisfair, giving you options for a streamlined home base, a more defined work-from-home setup, or extra space to spread out.</p><p>As you compare layouts, look for the details that make each residence feel finished from day one: polished concrete or hardwood-style flooring, high ceilings, granite countertops, efficient appliances, generous closets, in-home laundry features, and select city views, balconies, walk-in showers, or floor-to-ceiling windows. Browse current pricing and availability, explore more <a class=\"richtext-link\" href=\"/amenities\">apartment features</a>, then <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> to see which floor plan feels right in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Picture the view before you visit.</strong> THE'68 at Hemisfair photo gallery brings the building into focus through bright interiors, clean modern finishes, and the everyday scenes that make this Hemisfair address feel connected from the moment you arrive.</p><p>Scroll through kitchens with granite counters and sleek appliances, living areas framed by high ceilings and wide windows, and bedrooms that keep the look simple, polished, and calm. Then step into the community side: a roof deck made for sunny pauses, a fitness center with city energy in the background, and a rooftop basketball and pickleball court that turns the skyline into part of the game. As you browse, compare the spaces you like most with the full amenity collection, explore virtual tours, or schedule a tour to see the details in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Start with the map, then step into it.</strong> Around THE'68 at Hemisfair, Hemisfair feels less like a landmark and more like your everyday route—morning coffee at Box St. All Day, Neapolitan pizza at Dough, a glass at Re:Rooted 210, or a scoop from Lick Honest Ice Creams just beyond the lobby.</p><p>Civic Park brings the neighborhood’s rhythm into focus with the Great Lawn, The Springs, and a Mexican Sycamore-lined promenade that connects to Yanaguana Garden and points you toward downtown, Southtown, and the River Walk. Public art, shaded paths, patios, festivals, and quick bites give each block a reason to linger. Explore the map, then <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> to see how this Hemisfair address puts San Antonio’s park-district energy right outside your door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Pet-friendly living, minus the extra hassle.</strong></p><p>At THE'68 at Hemisfair, your four-legged family members are part of the community. We proudly welcome <strong>dogs and cats of all breeds and sizes, with no breed restrictions or weight limits</strong>, so you can feel right at home with your best friend.</p><p>Make pet care easy with an <strong>on-site pet-washing station and pet-relief station</strong>, plus convenient elevator access for quick trips outside. When you’re ready to get some fresh air, explore the nearby Hemisfair with your pup for leashed walks, open lawn space, shaded seating, and convenient Mutt Mitt stations.</p><p>We’re also proud to support local animal shelters. <strong>Adopt your dog or cat from a local animal shelter, provide your adoption paperwork, and we’ll waive your pet deposit.</strong> It’s our way of making it a little easier to give a new best friend a forever home.</p><p>From everyday convenience to spaces designed with pets in mind, THE'68 makes downtown San Antonio living better for everyone—including the four-legged members of your household.</p><p><a class=\"richtext-link\" href=\"https://vibesites.multihub.io/schedule-a-tour\">schedule a tour</a> and discover your new home at THE'68.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>We believe in supporting local animal shelters. When you adopt your dog or cat from a local animal shelter and provide adoption paperwork, we’ll waive your pet deposit. Bring your new best friend home and enjoy a community where pets are welcome!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 12pt;\">We welcome dogs and cats of all breeds and sizes, with no breed restrictions or weight limits.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>From rooftop play to city views, amenities at THE'68 at Hemisfair cover real ground.</strong> Recharge in our amazing fitness center, take on basketball or pickleball with a skyline backdrop. Garage parking, bike storage, gated electronic entry, on-site management, storage options, WiFi, pet spa access, and on-site spots to dine, sip, and grab dessert bring downtown San Antonio convenience right to the building.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Resident Access at THE'68 at Hemisfair.</strong><br>Log in to pay rent, submit maintenance requests, and manage your account—so everyday details stay as streamlined as your downtown San Antonio home in the heart of Hemisfair.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Hear what residents love about THE'68 at Hemisfair.</strong> Reviews point to a polished, well-kept setting, responsive management, and maintenance that’s quick to help when requests come up. Residents also call out the everyday perks that make life here feel easy: bright apartments, standout views, secure garage access, a well-equipped fitness space, and rooftop courts among the <a class=\"richtext-link\" href=\"/amenities\">community amenities</a>.</p><p>Most of all, reviewers highlight the energy of Hemisfair living—“amazing views and in the middle of all the action,” with dining, downtown, and Southtown within easy reach. Read the reviews below to see how residents describe the experience in their own words.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>See downtown living from THE'68 at Hemisfair.</strong> Tour streamlined studio, one-, and two-bedroom apartments with polished concrete floors, high ceilings, granite countertops, and expansive city-framing windows—then step into the amenity spaces that bring Hemisfair energy home. Schedule your tour today.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "petscallout.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019e85db-45c6-7570-8b98-f085354e1af6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman holding a dog indoors."
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "interactive-map-hero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ]
};

export const styleOverrides = {
  "_section.HeroSolidBG": {
    "properties": {
      "opacity": "1"
    }
  },
  "gallery-hero.bg_image": {
    "properties": {
      "opacity": "0.8"
    }
  }
};
